import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { TranslationService } from "@services/translation.service";
import "./empty-state.component.scss";

@Component({
    selector: "empty-state",
    template: require("./empty-state.component.html")
})
export class EmptyStateComponent implements OnChanges {
    @Input() icon: string;

    @Input() title: string;
    @Input() text: string;

    @Input() subject: string;

    // Add CTA text / callback

    // ---

    isFontAwesome = false;

    constructor(private readonly translationService: TranslationService) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.subject) {
            this.title = this.translationService.t("EmptyState.DefaultTitle", this.subject);

            if (!this.text) {
                this.text = this.translationService.t("EmptyState.DefaultText", this.subject);
            }
        }

        if (changes["icon"]) {
            this.isFontAwesome = this.icon.indexOf("fa") == 0;
        }
    }
}
